module.exports = "/assets/data/c1091869fc6d6537beae277022ff9e24-DN9.data.json";